import React from 'react';
import styled from 'styled-components';
import {
  brandColours,
  brandFonts,
  fontSize,
  maxBreakpointQuery,
  minBreakpointQuery,
  visuallyHidden,
  zIndexLayers,
} from '../styles';

const StyledModal = styled.aside`
  position: fixed;
  top: 50%;
  left: 20px;
  transform: translateY(-50%);
  overflow: hidden;
  flex-direction: column;
  max-width: 700px;
  z-index: ${zIndexLayers.sixth};
  display: ${({ isOpen }) => (isOpen ? 'flex' : 'none')};
  background-color: ${brandColours.quaternary};

  ${maxBreakpointQuery.smedium`
    right: 20px;
  `}

  ${minBreakpointQuery.smedium`
    left: 50%;
    transform: translateY(-50%) translateX(-50%);
    width: 100%;
  `}
`;

const StyledHeader = styled.header`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: ${({ alignItems }) => (alignItems ? alignItems : 'center')};
  padding: 18px;
`;

const StyledHeading = styled.h3`
  ${brandFonts.secondary}
  ${fontSize(30)}

  ${minBreakpointQuery.medium`
    ${fontSize(35)}
  `}
`;

const StyledClose = styled.button`
  align-self: end;
  border: none;
  padding: 0;

  &:before {
    content: '✕';
    ${fontSize(26)};
  }

  span {
    ${visuallyHidden()};
  }
`;

export const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 25px;
  overflow: ${({ removeOverflow }) => (removeOverflow ? 'unset' : 'auto')};

  ${minBreakpointQuery.small`
    padding: 0 45px;
  `}

  ${minBreakpointQuery.smedium`
    padding: 0 50px;
  `}

  ${minBreakpointQuery.medium`
    padding: 0 55px;
  `}

  ${minBreakpointQuery.mlarge`
    padding: 0 60px;
  `}
`;

const Modal = ({
  heading,
  children,
  alignItems,
  hideClose,
  isOpen,
  toggleOpen,
  ...props
}) => (
  <StyledModal isOpen={isOpen} {...props}>
    <StyledHeader alignItems={alignItems}>
      {!hideClose && (
        <StyledClose type="button" onClick={toggleOpen}>
          <span>Close</span>
        </StyledClose>
      )}
      {heading && <StyledHeading>{heading}</StyledHeading>}
    </StyledHeader>
    {children}
  </StyledModal>
);

export default Modal;
